import { Box, Container } from "@mui/material";
import AdminLogin from "../../components/admin/admin/AdminLogin";
const LoginPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 3,
        transition: "background-color 0.3s",
        marginTop:'30vh'
      }}
    >
      <Container
        sx={{
          my: 5,
          py: 5,
          borderRadius: 2,
          backgroundColor:  "white",
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
          maxWidth: "500px",
        }}
      >
        <AdminLogin />
      </Container>
    </Box>
  );
};

export default LoginPage;
